/**
 * @ngdoc service
 * @name ims.shared.data.service:zoneHistoryCollection
 * @description
 * A collection of ims ZoneHistory objects. It handles loading and refreshing data.
 *
 */
/**
 * @ngdoc event
 * @name ims.shared.data.service:zoneHistoryCollection#ZoneHistoryCollection:Changed
 * @eventOf ims.shared.data.service:zoneHistoryCollection
 * @eventType emit on root scope
 * @description
 * Emitted when the ZoneHistoryCollection is changed/updated.
 *
 * @param {Object} angularEvent Synthetic event object.
 */

import { ImsObjectIncrementalCollection } from './../ims_object_incremental_collection.service';
import { ZoneHistoryResource } from '../../resources';
import { ZoneHistory } from './zone_history';
import { ViewStateService } from '../../view_state.service';
import { SiteStateService } from '../../site_state.service';
import { StartupRegistry } from 'app/startup/registry/registry';
import { ILocalStorageService } from 'angular-local-storage';

export class ZoneHistoryCollection extends ImsObjectIncrementalCollection {
    constructor(
        startUpRegistry: StartupRegistry,
        localStorageService: ILocalStorageService,
        $rootScope,
        $interval,
        viewStateService: ViewStateService,
        siteStateService: SiteStateService,
    ) {
        super(
            startUpRegistry,
            localStorageService,
            $rootScope,
            $interval,
            viewStateService,
            siteStateService,
            ZoneHistoryResource,
            ZoneHistory,
        );
    }

    refreshData(params = {}, checkTime = false, useInFlightCheck = false) {
        return super.refreshData(
            {
                site_id: this._siteStateService.selectedSiteId,
            },
            checkTime,
            useInFlightCheck,
        );
    }
}
